<template>
  <div class="container page">
    <van-nav-bar :title="this.vod_name" class="nav-bar">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()" />
      </template>
    </van-nav-bar>
    <div class="right">
      <van-tabs
        v-model="activeGenderTab"
        animated
        :swipeable="true"
        line-width="60px"
        class="gender-tabs"
        @change="onGenderTabChange"
      >
        <van-tab :title="$t('女模')">
          <van-pull-refresh v-model="isLoading" border="false" class="list-wrapper" @refresh="onRefresh">
            <div class="lady-list-wrap">
              <van-loading v-if="femaleLoading" class="list-loading" color="#7e5678" size="40px" vertical>{{ $t('加载中') }}</van-loading>
              <div v-else class="lady-list">
                <ModelCard :info="v" v-for="v in femaleList" :key="v.id" :sex="2" />
                <div class="hot-recommend-more">{{ $t('没有更多了') }}</div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="$t('男模')">
          <van-pull-refresh v-model="isLoading" border="false" class="list-wrapper" @refresh="onRefresh">
            <div class="lady-list-wrap">
              <van-loading v-if="maleLoading" class="list-loading" color="#7e5678" size="40px" vertical>{{ $t('加载中') }}</van-loading>
              <div v-else class="lady-list">
                <ModelCard :info="v" v-for="v in maleList" :key="v.id" :sex="1" />
                <div class="hot-recommend-more">{{ $t('没有更多了') }}</div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import ModelCard from '@/components/ModelCard.vue'

export default {
  components: { ModelCard },
  data() {
    return {
      vod_name: '北京',
      isLoading: false,
      activeGenderTab: 0,
      femaleList: [],
      maleList: [],
      femaleLoading: false,
      maleLoading: false
    }
  },
  methods: {
    back() {
      this.$router.push({ path: 'Choose' })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('刷新成功') + '！')
        const listKey = ['femaleList', 'maleList'][this.activeGenderTab]
        this[listKey] = []
        this.getModelList(this.activeGenderTab)
        this.isLoading = false
      }, 500)
    },
    profile(id) {
      this.$router.push({ path: '/profile?id=' + id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id })
    },
    getModelList(tabIndex = 0) {
      const listKey = ['femaleList', 'maleList'][tabIndex]
      const loadingKey = ['femaleLoading', 'maleLoading'][tabIndex]
      this[loadingKey] = true
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: this.$route.query.id, sex: tabIndex === 0 ? 2 : 1 }
      }).then((res) => {
        this[listKey] = res.data
      }).finally(() => {
        this[loadingKey] = false
      })
    },
    onGenderTabChange(tabIndex) {
      const listKey = ['femaleList', 'maleList'][tabIndex]
      if (this[listKey].length === 0) {
        this.getModelList(tabIndex)
      }
    }
  },
  created() {
    this.vod_name = this.$route.query.name
    this.getModelList()
  }
}
</script>

<style scoped lang="less">
.container {
  background-color: #fff;
}
.right {
  background-color: #fff;
}

::v-deep .van-grid-item__content--center {
  border-radius: 15px;
  padding: 0;
  height: auto;
}

::v-deep .van-image__img {
  border-radius: 10px;
  padding: 15px;
}

.rig-name {
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin-top: 10px;
  background-color: #f7f7f7;
  border-radius: 0 0 15px 15px;
  font-size: 15px;
  padding-left: 10px;
}

.lady-list {
  display: flex;
  width: calc(100% - 50px);
  margin: 0 auto;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

.gender-tabs {
  ::v-deep .van-tab {
    font-size: 28px;
    font-weight: bold;
    color: #979799;
  }

  ::v-deep .van-tab--active {
    color: #7e5678;
  }

  ::v-deep .van-tabs__line {
    background-color: #7e5678;
    height: 4px;
    border-radius: 2px;
  }

  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 80px;
  }
}

.lady-list-wrap {
  min-height: 100vh; 
}

.list-loading {
  display: flex;
  justify-content: center;
  padding: 60px 0;
  font-size: 26px;
  color: #7e5678;
}

// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  // 导航栏PC端适配
  .nav-bar {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar {
    line-height: 57px !important;
  }

  ::v-deep .van-nav-bar__content {
    height: 57px !important; /* 100px * 0.5733 ≈ 57px */
  }

  ::v-deep .van-nav-bar__title {
    font-size: 20px !important; /* 35px * 0.5733 ≈ 20px */
    max-width: 60% !important;
  }

  ::v-deep .van-nav-bar .van-icon {
    font-size: 26px !important; /* 45px * 0.5733 ≈ 26px */
  }

  // 列表容器PC端适配
  .lady-list {
    width: calc(100% - 29px); /* 50px * 0.5733 ≈ 29px */
  }

  // "没有更多了"文字PC端适配
  .hot-recommend-more {
    padding-bottom: 11px; /* 20px * 0.5733 ≈ 11px */
    font-size: 17px; /* 30px * 0.5733 ≈ 17px */
  }

  .gender-tabs {
    ::v-deep .van-tab {
      font-size: 16px;
    }

    ::v-deep .van-tabs--line .van-tabs__wrap {
      height: 46px;
    }
  }

  // 下拉刷新PC端适配
  ::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
    font-size: 20px; /* 35px * 0.5733 ≈ 20px */
  }
}
</style>
